module.exports = __webpack_public_path__ + "static/media/34.4b3587a1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/34.svg
// module id = 145
// module chunks = 0